import React, { Component } from 'react';
import Theme from './Theme';
import TemplateMarketDialog from './TemplateMarketDialog';
import OnboardingGallery from 'components/OnboardingGallery';
import * as billing from 'modules/billing';
import { GalleryTemplates } from '../../config/template_gallery';
import { injectIntl } from 'react-intl';

let _dialogVisible = false;

class Themes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOnboarding: false,
            onboardingSkipped: false,
            showDialog: _dialogVisible,
            showMoreMenu: false,
            activeIdx: this.getDefaultIdx(props)
        };
    }

    getDefaultIdx(props) {
        const themes = props.themes || [];
        const primaryIdx = themes.findIndex(t => t && t.isPrimary);
        return primaryIdx >= 0 ? primaryIdx : 0;
    }

    showDialog() {
        _dialogVisible = true;
        this.setState({ showDialog: true });
        if (this._templateMarketDialog && this._templateMarketDialog.wrappedInstance && this._templateMarketDialog.wrappedInstance.wrappedInstance) {
            this._templateMarketDialog.wrappedInstance.wrappedInstance.show();
        }
    }

    componentDidMount() {
        if (_dialogVisible && this._templateMarketDialog && this._templateMarketDialog.wrappedInstance && this._templateMarketDialog.wrappedInstance.wrappedInstance) {
            this._templateMarketDialog.wrappedInstance.wrappedInstance.show();
        }
    }

    render() {
        let { fields, themes, dispatch, user, intl } = this.props;
        const t = (id) => intl.formatMessage({ id });
        const { showOnboarding, onboardingSkipped, activeIdx } = this.state;

        const hasNoThemes = !themes || themes.length === 0;
        const hasModernTemplate = themes && themes.some(t => t.bodyTemplate && t.bodyTemplate.indexOf('settings.') !== -1);
        const allLegacy = !hasNoThemes && !hasModernTemplate;
        const shouldShowOnboarding = (hasNoThemes || (allLegacy && !onboardingSkipped)) && !onboardingSkipped;

        if (shouldShowOnboarding || showOnboarding) {
            return <div>
                <OnboardingGallery
                    onInstall={(templateNames, config) => {
                        dispatch(billing.installTheme({ themes: templateNames, config }));
                    }}
                    onSkip={() => {
                        if (allLegacy) {
                            this.setState({ onboardingSkipped: true, showOnboarding: false });
                        } else {
                            const retailTemplates = GalleryTemplates.filter(t => t.industry === 'retail' && !t.isUniversal).map(t => t.name);
                            dispatch(billing.installTheme({ themes: retailTemplates }));
                        }
                    }}
                    hasLegacyTemplates={allLegacy}
                    user={user}
                />
                <TemplateMarketDialog onOk={(theme)=>{
                    _dialogVisible = false;
                    dispatch(billing.installTheme(theme));
                }} onHide={()=>{
                    _dialogVisible = false;
                }} ref={(i)=>{
                    this._templateMarketDialog = i;
                    if (_dialogVisible && i && i.wrappedInstance && i.wrappedInstance.wrappedInstance) {
                        i.wrappedInstance.wrappedInstance.show();
                    }
                }} />
            </div>;
        }

        const safeIdx = themes[activeIdx] ? activeIdx : 0;

        return <div>
            <style>{`
.template-tabs { display: flex; align-items: center; gap: 0; border-bottom: 2px solid #e2e8f0; margin-bottom: 0; padding: 0; flex-wrap: nowrap; }
.template-tab { padding: 10px 16px; font-size: 12px; font-weight: 500; color: #64748b; cursor: pointer; border: none; background: none; white-space: nowrap; position: relative; transition: color 0.15s; border-bottom: 2px solid transparent; margin-bottom: -2px; }
.template-tab:hover { color: #334155; background: #f8fafc; }
.template-tab.active { color: #1e3a5f; border-bottom-color: #1e3a5f; font-weight: 600; }
.template-tab .fa-star { color: #f59e0b; margin-right: 4px; font-size: 10px; }
.template-tab-more { padding: 10px 14px; font-size: 12px; font-weight: 600; color: #64748b; cursor: pointer; border: none; background: none; white-space: nowrap; margin-bottom: -2px; border-bottom: 2px solid transparent; position: relative; }
.template-tab-more:hover { color: #334155; background: #f8fafc; }
.template-tab-more.has-active { border-bottom-color: #1e3a5f; color: #1e3a5f; }
.template-more-menu { position: absolute; top: 100%; right: 0; background: #fff; border: 1px solid #e2e8f0; border-radius: 6px; box-shadow: 0 8px 24px rgba(0,0,0,0.12); z-index: 100; min-width: 200px; padding: 4px 0; margin-top: 4px; }
.template-more-menu button { display: block; width: 100%; text-align: left; padding: 8px 16px; font-size: 12px; border: none; background: none; cursor: pointer; color: #334155; }
.template-more-menu button:hover { background: #f1f5f9; }
.template-more-menu button.active { color: #1e3a5f; font-weight: 600; background: #f0f8ff; }
.template-more-menu button .fa-star { color: #f59e0b; margin-right: 4px; font-size: 10px; }
.template-tab-add { padding: 7px 16px; font-size: 12px; font-weight: 600; color: #fff; cursor: pointer; border: none; background: #1e3a5f; border-radius: 4px; margin-left: auto; white-space: nowrap; transition: all 0.15s; }
.template-tab-add:hover { background: #0f2a4a; }
            `}</style>

            <div className="template-tabs">
                {(() => {
                    const maxVisible = 6;
                    const visibleThemes = [];
                    const overflowThemes = [];
                    fields.forEach((theme, idx) => {
                        if (!themes[idx]) return;
                        if (visibleThemes.length < maxVisible) {
                            visibleThemes.push(idx);
                        } else {
                            overflowThemes.push(idx);
                        }
                    });
                    // If active tab is in overflow, swap it into visible
                    if (overflowThemes.includes(safeIdx)) {
                        const swapOut = visibleThemes[visibleThemes.length - 1];
                        visibleThemes[visibleThemes.length - 1] = safeIdx;
                        overflowThemes.splice(overflowThemes.indexOf(safeIdx), 1);
                        overflowThemes.unshift(swapOut);
                    }
                    const tabs = visibleThemes.map(idx => (
                        <button
                            key={idx}
                            type="button"
                            className={`template-tab${safeIdx === idx ? ' active' : ''}`}
                            onClick={() => this.setState({ activeIdx: idx })}
                        >
                            {themes[idx].isPrimary && <i className="fa fa-star"></i>}
                            {themes[idx].name || `Template ${idx + 1}`}
                        </button>
                    ));
                    if (overflowThemes.length > 0) {
                        tabs.push(
                            <button
                                key="more"
                                type="button"
                                className={`template-tab-more${overflowThemes.includes(safeIdx) ? ' has-active' : ''}`}
                                onClick={() => this.setState({ showMoreMenu: !this.state.showMoreMenu })}
                                onBlur={() => setTimeout(() => this.setState({ showMoreMenu: false }), 150)}
                            >
                                <i className="fa fa-ellipsis-h"></i> +{overflowThemes.length}
                                {this.state.showMoreMenu && (
                                    <div className="template-more-menu">
                                        {overflowThemes.map(idx => (
                                            <button
                                                key={idx}
                                                type="button"
                                                className={safeIdx === idx ? 'active' : ''}
                                                onClick={() => this.setState({ activeIdx: idx, showMoreMenu: false })}
                                            >
                                                {themes[idx].isPrimary && <i className="fa fa-star"></i>}
                                                {themes[idx].name || `Template ${idx + 1}`}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </button>
                        );
                    }
                    return tabs;
                })()}
                <button type="button" className="template-tab-add" onClick={() => this.showDialog()}>
                    <i className="fa fa-plus"></i> {t('templateEditor.installNewTemplate')}
                </button>
            </div>

            {themes[safeIdx] && <Theme
                key={safeIdx}
                dispatch={dispatch}
                fields={fields}
                theme={themes[safeIdx]}
                themes={themes}
                user={user}
                intl={intl}
                idx={safeIdx}
                onClick={() => {
                    fields.remove(safeIdx);
                    this.setState({ activeIdx: Math.max(0, safeIdx - 1) });
                }}
                el={`themes[${safeIdx}]`}
            />}

            <TemplateMarketDialog onOk={(theme)=>{
                _dialogVisible = false;
                dispatch(billing.installTheme(theme));
            }} onHide={()=>{
                _dialogVisible = false;
            }} ref={(i)=>{
                this._templateMarketDialog = i;
                if (_dialogVisible && i && i.wrappedInstance && i.wrappedInstance.wrappedInstance) {
                    i.wrappedInstance.wrappedInstance.show();
                }
            }} />
        </div>
    }
}

export default injectIntl(Themes);



// WEBPACK FOOTER //
// app/containers/Themes.jsx